import { useMutation } from '@tanstack/react-query';
import type { OrganizationRequest } from '../types/Organization';

export default function useUpdateOrganization() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async (params: OrganizationRequest) => {
      const response = await fetch('/agent/api/organization', {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify(params),
      });
      if (!response.ok) {
        let message = 'Failed to update organization';
        try {
          const data = await response.json();
          message = data?.errors?.[0] ?? data?.message ?? message;
        } catch (error) {
          console.error(error);
        }
        throw new Error(message);
      }
      return await response.json();
    },
  });
}
